import { theme } from 'pfm-ui-components';

export const pxToRemPure = px => px / theme.fonts.baseFontSize
export const pxToRem = (px) => `${px / theme.fonts.baseFontSize}rem`;

export const hexToRgba = (color, alpha) => {
  const [r, g, b] = color.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export const getHexColorWithOpacity = (color, opacity) => {
  const opacityPercent = Math.round(opacity * 100) / 100;
  const alpha = Math.round(opacityPercent * 255);
  let hex = alpha.toString(16).toUpperCase();
  if (hex.length == 1) hex = '0' + hex;

  return `${color}${hex}`;
};
